export default "__VITE_ASSET__BVR28x9M__"